import type { AvailableViewsResponseBody } from '../contracts/availableViews';
import { toAvailableViewSummary } from '../contracts/availableViews';
import type { DefectOverlayTenantOptions } from './tenantDefectOverlayAdapter';
import {
  collectAdapterRecipes,
  isCuratedOverlayRecipeId,
  resolveTenantDefectOverlayAdapters,
} from './tenantDefectOverlayRegistry';

export function mergeDefectOverlayViews(
  body: AvailableViewsResponseBody,
  options?: DefectOverlayTenantOptions,
): AvailableViewsResponseBody {
  const adapters = resolveTenantDefectOverlayAdapters(options);

  const scopedBodyViews = body.views.filter(
    (view) => !isCuratedOverlayRecipeId(view.id),
  );

  const overlayViews = collectAdapterRecipes(adapters).map(
    toAvailableViewSummary,
  );

  if (overlayViews.length === 0) {
    return { views: scopedBodyViews };
  }

  const byId = new Map(scopedBodyViews.map((view) => [view.id, view]));
  for (const overlay of overlayViews) {
    byId.set(overlay.id, overlay);
  }

  return {
    views: Array.from(byId.values()),
  };
}
